import * as tslib_1 from "tslib";
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
/**
 * Example of a String Time adapter
 */
var NgbDateConverter = /** @class */ (function (_super) {
    tslib_1.__extends(NgbDateConverter, _super);
    function NgbDateConverter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NgbDateConverter.prototype.fromModel = function (value) {
        if (!value) {
            return null;
        }
        var split = value.split('-', 3);
        return {
            day: parseInt(split[0], 10),
            month: parseInt(split[1], 10),
            year: parseInt(split[2], 10)
        };
    };
    NgbDateConverter.prototype.toModel = function (date) {
        if (!date) {
            return null;
        }
        return this.pad(date.year) + "-" + this.pad(date.month) + "-" + this.pad(date.day);
    };
    NgbDateConverter.prototype.pad = function (i) {
        return i < 10 ? "0" + i : "" + i;
    };
    return NgbDateConverter;
}(NgbDateAdapter));
export { NgbDateConverter };



// WEBPACK FOOTER //
// ./src/app/bi/common/service/ngbDateConverter.utils.ts.pre-build-optimizer.js